<template>
  <section>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(checkSave)">
        <div class="modal-card" style="width: 1080px">
          <header class="modal-card-head">
            <p v-if="update" class="modal-card-title">Editar Afiliación</p>
            <p v-else class="modal-card-title">Agregar Nueva Afiliación</p>
            <button type="button" class="delete" @click="$emit('close')" />
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <div class="mb-2" v-if="Object.keys(errores_validacion).length !== 0">
                  <b-message type="is-danger" has-icon>
                    <div v-for="(item,index) in errores_validacion">
                      <div v-if="item">{{ item[0] }}</div>
                    </div>
                  </b-message>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <ValidationProvider name="Nombre Institución" rules="min:3|max:255|required"
                  v-slot="{ errors, failedRules }">
                  <b-field :type="{ 'is-danger': isPartnerEntityRegister || Object.keys(failedRules).length > 0 }"
                    :message="{ 'Debe añadir una entidad registrada': isPartnerEntityRegister || Object.keys(failedRules).length > 0 }"
                    label="Nombre Institución *">
                    <b-autocomplete v-model="related_institution.partner_entity_name" :keep-first="keepFirst"
                      :open-on-focus="openOnFocus" :data="partner_entities" field="show_name" empty="Vacio"
                      @typing="searchPartnerEntities"
                      @select="option => {if (option) {related_institution.partner_entity_id = option.id} }"
                      :clearable="clearable" placeholder="Ej: Sociedad Chilena de Ciencia de la Computación">
                      <template slot-scope="props">
                        {{ props.option.show_name ? props.option.show_name : props.option.name}}
                      </template>
                    </b-autocomplete>
                  </b-field>
                </ValidationProvider>

              </div>
              <div class="column is-narrow">
                <br>
                <b-field label=" ">
                  <b-tooltip label="Si la entidad que desea agregar no existe, la puede agregar presionando el botón +"
                    position="is-left">
                    <b-button class="is-primary is-outlined" @click="addEntity()">
                      <b-icon icon="plus"></b-icon>
                    </b-button>
                  </b-tooltip>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <ValidationProvider name="Miembro en Calidad de" rules="min:3|max:255|required"
                  v-slot="{ errors, failedRules }">
                  <b-field label="Miembro en Calidad de *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-input v-model="related_institution.type_member" placeholder="Ej: Tesorero, Regular, etc" />
                  </b-field>
                </ValidationProvider>

              </div>
            </div>
            <div class="columns mb-6">
              <div class="column">
                <ValidationProvider name="Fecha de Inicio"
                  :rules="{ start_date_before_end_date: related_institution.end_date, required: true }"
                  v-slot="{ errors, failedRules }">
                  <b-field label="Fecha de Inicio *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-datepicker v-model="related_institution.start_date" icon="calendar-alt" trap-focus locale="es-ES"
                      editable placeholder="dd/mm/aaaa" />
                  </b-field>
                </ValidationProvider>
              </div>

              <div class="column">
                <ValidationProvider name="Fecha de Término"
                  :rules="{ end_date_not_before_start_date: related_institution.start_date }"
                  v-slot="{ errors, failedRules }">
                  <b-field label="Fecha de Término" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-datepicker v-model="related_institution.end_date" icon="calendar-alt" trap-focus locale="es-ES"
                      editable placeholder="dd/mm/aaaa">
                    </b-datepicker>
                  </b-field>
                </ValidationProvider>
              </div>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
          </section>
        </div>
        <footer class="modal-card-foot is-flex is-justify-content-space-between">
          <b-button label="Cerrar" @click="$emit('close')" />
          <b-button label="Guardar Datos" type="is-primary" @click="checkSave()" />
        </footer>
        <b-modal v-model="isAddModalEntityActive" :destroy-on-hide="true" width="55%" :can-cancel="canCancel">
          <template #default="props">
            <modal_partner_entity query-type="update" modal-header="Añadir nueva entidad" @close="props.close"
              @clicked="onClickChild"></modal_partner_entity>
          </template>
        </b-modal>
      </form>
    </ValidationObserver>
  </section>
</template>

<script>
import axios from "axios";
import modal_partner_entity from "../moduloVIME/agreements/new/modal_partner_entity"
import moment from "moment";

export default {
  name: "modal_new_related_institution",
  props: ['update','personId','old_related_institution'],
  components:{modal_partner_entity},
  data(){
    return{
      related_institution: {},
      keepFirst: false,
      openOnFocus: false,
      clearable: false,
      partner_entities:[],
      isAddModalEntityActive: false,
      canCancel: false,
      errores_validacion: {},
      isPartnerEntityRegister: false,
      partner_entity_name: '',
      isLoading: false
    }
  },
  async created() {
    await this.initialize()
  },
  methods:{
    async initialize(){
      if(this.update){
        this.isLoading = true
        await this.getRelatedInstitution()
      }
    },
    async getRelatedInstitution() {
      await axios
          .get('/related_institutions/'+this.old_related_institution.id+'.json')
          .then(response => {
            this.related_institution = response.data
            this.related_institution.start_date = moment(this.related_institution.start_date, ["YYYY-MM-DD","DD-MM-YYYY"])._d;
            if (this.related_institution.end_date != null){
              this.related_institution.end_date = moment(this.related_institution.end_date, ["YYYY-MM-DD","DD-MM-YYYY"])._d;
            }
          })
          .catch(error => {
            this.$buefy.dialog.alert({
              title: 'Error',
              message: 'Hubo un error al obtener los datos. Intente más tarde',
              type: 'is-danger',
              hasIcon: true,
              icon: 'times-circle',
              iconPack: 'fa',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
            this.errores_validacion = error.response.data
            this.$emit('close')
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    async checkSave(){
      const valid = await this.$refs.observer.validate()
      this.isPartnerEntityRegister = false
      if(!valid){
        this.$buefy.dialog.alert({
          message: 'Faltan algunos campos o presentan errores de formato.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      else{
        if (this.related_institution.partner_entity_name != '' && this.related_institution.partner_entity_name != null) {
          if (this.related_institution.partner_entity_id == null) {
            this.isPartnerEntityRegister = true
          } else {
            this.saveRelatedInstitution()
          }
        }
        else{
          this.saveRelatedInstitution()
        }
      }
    },
    async saveRelatedInstitution(){
      this.isLoading = true
      this.related_institution.person_id = this.personId
      if(this.update){
        await axios
            .put('/related_institutions/'+this.old_related_institution.id+'.json', {
              related_institution: this.related_institution
            })
            .then(response => {
              this.$buefy.dialog.alert({
                message: 'Los datos fueron actualizados satisfactoriamente.',
                confirmText: 'Ok'
              });
              this.errores_validacion = {}
              this.$emit('close')
              this.$emit('refresh')
            })
            .catch(error => {
              console.log(error)
              this.errores_validacion = error.response.data
              this.$buefy.dialog.alert({
                title: 'Error',
                message: 'Ocurrio un error al editar los datos.',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
              });
            })
            .finally(() => {
              this.isLoading = false
            })
      }
      else{
        await axios
            .post('/related_institutions.json', {
              related_institution: this.related_institution
            })
            .then(response => {
              this.$buefy.dialog.alert({
                message: 'Los datos fueron guardados satisfactoriamente.',
                confirmText: 'Ok'
              });
              this.errores_validacion = {}
              this.$emit('close')
              this.$emit('refresh')
            })
            .catch(error => {
              console.log(error)
              this.errores_validacion = error.response.data
              this.$buefy.dialog.alert({
                title: 'Error',
                message: 'Ocurrio un error al guardar los datos.',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
              });
            })
            .finally(() => {
              this.isLoading = false
            })
      }
    },
    searchPartnerEntities(name){
      this.related_institution.partner_entity_id = null
      if (name.length<3) {
        this.partner_entities = []
        return
      }
      let vm = this;
      vm.isLoading=true;
      axios
          .get("/admin/partner_entities/agreement-search.json", { params: {
              name: name
            } })
          .then(res => {
            vm.partner_entities = res.data;
            this.errores_validacion = {}
          })
          .catch(error => {
            console.log(error)
            this.errores_validacion = error.response.data
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    clearEntity(){
      this.related_institution.partner_entity_id = null
      this.related_institution.partner_entity_name = null
    },
    onClickChild(value){
      this.isPartnerEntityRegister = false
      if(value.name != '' && value.name != null){
        this.related_institution.partner_entity_name = value.name
      }
      else{
        this.related_institution.partner_entity_name = value.full_name
      }
      this.related_institution.partner_entity_id = value.id
    },
    addEntity(){
      this.isAddModalEntityActive = true;
    },
  }
}
</script>

<style scoped>

</style>